import React from "react";
import { useSelector } from "react-redux";

const Diagramm = () => {
	const selectedMonthYear = useSelector((state) => state.selectedMonthYear);
	const data = useSelector((state) => state.data);
	const selectedData = data && data.monthYear ? data.monthYear.find((entry) => entry.monthYear === selectedMonthYear) : null;

	let countOperations = 0;
	const content =
		selectedData && selectedData.days
			? selectedData.days.map((entry, index) => {
					countOperations += entry.countOperations;
					return (
						<div key={index} className={entry.class ? entry.class : ""}>
							<div className="dayName">{entry.dayName}</div>
							<div className="day" style={{ width: (100 / data.maxValue) * entry.countOperations + "%" }}>
								<span>{entry.countOperations}</span>
							</div>
						</div>
					);
			  })
			: null;

	return (
		<div id="proMonat" className="diagramm">
			<div className="monthRows">{content}</div>
			<div className="countOperations">Total Einsätze: {countOperations.toLocaleString("de-CH")}</div>
		</div>
	);
};

export default Diagramm;
